// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiGrid-root.settingMainContainer {
  padding: 20px 30px;
 
}

.MuiGrid-root.settingContainer {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding-left: 20px;
}

.MuiBox-root.settingMenu {
  background-color: #292B49;
  width: 100%;
  margin-top: 30px;
  max-height: 400px; 
  overflow-y: auto;
  height: max-content;
}

.MuiTypography-root.menuLabel {
  color: #FFFFFF;
  opacity: 0.5;
  font-size: 16px;
  font-weight: 400;
  font-family: var(--font-family-primary);
  margin: 10px 0;
  text-align: center;
  justify-content: center;
  padding: 10px;
}

.MuiBox-root.active {
  background-color: #35375B;
}

.MuiTypography-root.menuLabel:hover {
  background-color: #35375B;
}

.MuiBox-root.settingContent {
  width: 100%;
}

@media screen and (min-width: 600px) {
  .MuiGrid-root.settingContainer {
    flex-direction: row;
    flex-wrap: nowrap;
  }



}

/* social page styles */
.social-connect-container {
  /* min-height: 100vh; */
  padding: 2rem;
  font-family: var(--font-family-primary);
  height: calc(100dvh - 200px);
}

.page-title {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 2rem;
  margin-top: 0;
}

.platforms-list {
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.platform-card {
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  backdrop-filter: blur(10px);
  transition: all 0.2s ease;
  align-items: center;
  border-bottom: 1px solid #575972;
}


.platform-header {
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  width: 100%
}




.platform-info {
  flex: 1 1;
}

.MuiTypography-root.platform-name {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  font-family: var(--font-family-primary);
}

.MuiTypography-root.platform-description {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  font-family: var(--font-family-primary);
  margin: 0 0 0.5rem 0;
  font-weight: 400;
}

.platform-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-end;
  width: 100%;
}

.platform-actions .MuiButtonBase-root {
  width: 100%;
}

.MuiButtonBase-root.disconnected {
  background: #585A73;
  border-color: #585A73;
  text-transform: none;
  color: #fff;
  font-weight: 400;
  border: none;
  font-family: var(--font-family-primary);
  border-radius: 5px;
  height: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;
  line-height: 1.2;
}

.MuiButtonBase-root.connected {
  background: #11B82F;
  border-color: #11B82F;
  text-transform: none;
  color: #fff;
  font-weight: 400;
  border: none;
  font-family: "var(--font-family-primary)";
  border-radius: 5px;
  height: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;
  line-height: 1.2;
}

.Muidisabled.connted {
  color: #FDFCFF;
}


/* Responsive Design */
@media (max-width: 768px) {
  .social-connect-container {
    padding: 1rem;
  }

  .platform-card {
    flex-direction: column;
    gap: 1rem;
  }

  .platform-actions {
    align-items: stretch;
    width: 100%;
  }

  .connect-button {
    width: 100%;
  }

  .special-button {
    align-self: flex-start;
  }
    .MuiGrid-root.settingMainContainer{
         height: calc(100dvh - 61px);
    overflow-y: auto;
  }
}

@media (max-width: 480px) {
  .platform-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.75rem;
  }

  .platform-icon {
    width: 40px !important;
    height: 40px !important;
    padding: 8px;
  }
}
@media screen and (min-width: 768px) {
 .MuiBox-root.settingMenu {
      max-width: 250px;
  }
  .MuiBox-root.settingContent{
    max-width: 82%;
  }
  
  
}

@media screen and (min-width: 1024px) {
  .platform-actions {
    width: 22%;
  }
  .MuiBox-root.settingContentItem{
    /* max-height: 85vh; */
    overflow-y: auto;
  }
  .platform-header{
    width: 66%;
  }
}
@media screen and (min-width: 1200px){
     .MuiGrid-root.settingMainContainer{
         height: calc(100dvh - 120px);
    overflow-y: hidden;
  }
   .MuiBox-root.settingContentItem{
    /* max-height: 85vh; */
    overflow-y: auto;
  }
}
@media screen and (max-width: 460px) {
  .MuiGrid-root.settingMainContainer {
  padding: 0;
}
.MuiBox-root.settingMenu {
  width: 100%;
  display: flex;
  
}
.MuiTypography-root.platform-description {
text-align: left;
display:none;
}
.platform-card {
  flex-direction: row;
}
}`, "",{"version":3,"sources":["webpack://./src/components/SettingPage/Setting.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;;;AAIF;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;AAClC;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT;AACF;;;;;AAKA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,uCAAuC;EACvC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;;AAGA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;IACE;SACK,2BAA2B;IAChC,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;AACF;AACA;CACC;MACK,gBAAgB;EACpB;EACA;IACE,cAAc;EAChB;;;AAGF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;AACF;AACA;KACK;SACI,4BAA4B;IACjC,kBAAkB;EACpB;GACC;IACC,sBAAsB;IACtB,gBAAgB;EAClB;AACF;AACA;EACE;EACA,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;;AAEf;AACA;AACA,gBAAgB;AAChB,YAAY;AACZ;AACA;EACE,mBAAmB;AACrB;AACA","sourcesContent":[".MuiGrid-root.settingMainContainer {\n  padding: 20px 30px;\n \n}\n\n.MuiGrid-root.settingContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  padding-left: 20px;\n}\n\n.MuiBox-root.settingMenu {\n  background-color: #292B49;\n  width: 100%;\n  margin-top: 30px;\n  max-height: 400px; \n  overflow-y: auto;\n  height: max-content;\n}\n\n.MuiTypography-root.menuLabel {\n  color: #FFFFFF;\n  opacity: 0.5;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: var(--font-family-primary);\n  margin: 10px 0;\n  text-align: center;\n  justify-content: center;\n  padding: 10px;\n}\n\n.MuiBox-root.active {\n  background-color: #35375B;\n}\n\n.MuiTypography-root.menuLabel:hover {\n  background-color: #35375B;\n}\n\n.MuiBox-root.settingContent {\n  width: 100%;\n}\n\n@media screen and (min-width: 600px) {\n  .MuiGrid-root.settingContainer {\n    flex-direction: row;\n    flex-wrap: nowrap;\n  }\n\n\n\n}\n\n/* social page styles */\n.social-connect-container {\n  /* min-height: 100vh; */\n  padding: 2rem;\n  font-family: var(--font-family-primary);\n  height: calc(100dvh - 200px);\n}\n\n.page-title {\n  color: #ffffff;\n  font-size: 1.5rem;\n  font-weight: 400;\n  margin-bottom: 2rem;\n  margin-top: 0;\n}\n\n.platforms-list {\n  max-width: 1000px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.platform-card {\n  padding: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  backdrop-filter: blur(10px);\n  transition: all 0.2s ease;\n  align-items: center;\n  border-bottom: 1px solid #575972;\n}\n\n\n.platform-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 2rem;\n  width: 100%\n}\n\n\n\n\n.platform-info {\n  flex: 1;\n}\n\n.MuiTypography-root.platform-name {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  font-family: var(--font-family-primary);\n}\n\n.MuiTypography-root.platform-description {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  line-height: 1.4;\n  margin: 0;\n  font-family: var(--font-family-primary);\n  margin: 0 0 0.5rem 0;\n  font-weight: 400;\n}\n\n.platform-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: flex-end;\n  width: 100%;\n}\n\n.platform-actions .MuiButtonBase-root {\n  width: 100%;\n}\n\n.MuiButtonBase-root.disconnected {\n  background: #585A73;\n  border-color: #585A73;\n  text-transform: none;\n  color: #fff;\n  font-weight: 400;\n  border: none;\n  font-family: var(--font-family-primary);\n  border-radius: 5px;\n  height: 44px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-sizing: border-box;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 1rem;\n  line-height: 1.2;\n}\n\n.MuiButtonBase-root.connected {\n  background: #11B82F;\n  border-color: #11B82F;\n  text-transform: none;\n  color: #fff;\n  font-weight: 400;\n  border: none;\n  font-family: \"var(--font-family-primary)\";\n  border-radius: 5px;\n  height: 44px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-sizing: border-box;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 1rem;\n  line-height: 1.2;\n}\n\n.Muidisabled.connted {\n  color: #FDFCFF;\n}\n\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .social-connect-container {\n    padding: 1rem;\n  }\n\n  .platform-card {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .platform-actions {\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .connect-button {\n    width: 100%;\n  }\n\n  .special-button {\n    align-self: flex-start;\n  }\n    .MuiGrid-root.settingMainContainer{\n         height: calc(100dvh - 61px);\n    overflow-y: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .platform-header {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 0.75rem;\n  }\n\n  .platform-icon {\n    width: 40px !important;\n    height: 40px !important;\n    padding: 8px;\n  }\n}\n@media screen and (min-width: 768px) {\n .MuiBox-root.settingMenu {\n      max-width: 250px;\n  }\n  .MuiBox-root.settingContent{\n    max-width: 82%;\n  }\n  \n  \n}\n\n@media screen and (min-width: 1024px) {\n  .platform-actions {\n    width: 22%;\n  }\n  .MuiBox-root.settingContentItem{\n    /* max-height: 85vh; */\n    overflow-y: auto;\n  }\n  .platform-header{\n    width: 66%;\n  }\n}\n@media screen and (min-width: 1200px){\n     .MuiGrid-root.settingMainContainer{\n         height: calc(100dvh - 120px);\n    overflow-y: hidden;\n  }\n   .MuiBox-root.settingContentItem{\n    /* max-height: 85vh; */\n    overflow-y: auto;\n  }\n}\n@media screen and (max-width: 460px) {\n  .MuiGrid-root.settingMainContainer {\n  padding: 0;\n}\n.MuiBox-root.settingMenu {\n  width: 100%;\n  display: flex;\n  \n}\n.MuiTypography-root.platform-description {\ntext-align: left;\ndisplay:none;\n}\n.platform-card {\n  flex-direction: row;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
